import type { FC, ReactElement } from "react";

import { SocialFacebookIcon } from "@jti/brand-icons/social-facebook";
import { SocialInstagramIcon } from "@jti/brand-icons/social-instagram";
import { SocialLineIcon } from "@jti/brand-icons/social-line";
import { SocialMailIcon } from "@jti/brand-icons/social-mail";
import { SocialSnapchatIcon } from "@jti/brand-icons/social-snapchat";
import { SocialTelegramIcon } from "@jti/brand-icons/social-telegram";
import { SocialViberIcon } from "@jti/brand-icons/social-viber";
import { SocialWhatsappIcon } from "@jti/brand-icons/social-whatsapp";
import { SocialXIcon } from "@jti/brand-icons/social-x";
import { SocialYoutubeIcon } from "@jti/brand-icons/social-youtube";
import type { CheckoutOrderSummarySocialMedia } from "@jti/commerce";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";

import styles from "./SocialMedia.module.scss";

type SocialIcons = {
  [x: string]: ReactElement;
};

const SOCIAL_ICONS: SocialIcons = {
  FACEBOOK: <SocialFacebookIcon className={styles.icon} />,
  INSTAGRAM: <SocialInstagramIcon className={styles.icon} />,
  LINE: <SocialLineIcon className={styles.icon} />,
  MAIL: <SocialMailIcon className={styles.icon} />,
  SNAPCHAT: <SocialSnapchatIcon className={styles.icon} />,
  TELEGRAM: <SocialTelegramIcon className={styles.icon} />,
  VIBER: <SocialViberIcon className={styles.icon} />,
  WHATS_UP: <SocialWhatsappIcon className={styles.icon} />,
  X: <SocialXIcon className={styles.icon} />,
  YOUTUBE: <SocialYoutubeIcon className={styles.icon} />,
};

type SocialIconProps = {
  link: CheckoutOrderSummarySocialMedia;
};

export const SocialIcon: FC<SocialIconProps> = ({ link }) => {
  const socialIcon = SOCIAL_ICONS[link.icon];

  if (!socialIcon) {
    return null;
  }

  return (
    <LinkBehaviour href={link.uri} target="_blank" rel="noreferrer" aria-label={link.icon}>
      {socialIcon}
    </LinkBehaviour>
  );
};
